import apis from '@src/apis';
import { uploadFileToS3 } from '@src/services/upload';
import { v4 as uuidv4 } from 'uuid';

const getAudioUrl = (file) => {
  if (!file) return '';
  if (file instanceof File) {
    return URL.createObjectURL(file);
  }
  if (typeof file === 'string') {
    return file;
  }
  return '';
};

const truncateFilename = ({
  filename,
  maxLength,
  maxLengthExt,
  maxLengthName,
}) => {
  if (!filename) return '';

  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) return filename;
  const name = filename.substring(0, lastDotIndex);
  const ext = filename.substring(lastDotIndex);

  if (name.length <= maxLength) return filename;

  const first = name.substring(0, maxLengthName);
  const last = name.substring(name.length - maxLengthExt);
  return `${first}...${last}${ext}`;
};

const handleCheckQualityAudio = async ({ fileUpload, audioRecord }) => {
  if (!fileUpload && !audioRecord) return null;
  const audioId = uuidv4();

  const handleUploadAudioToS3 = async () => {
    let file;
    let extension;
    if (audioRecord) {
      const response = await fetch(audioRecord);
      file = await response.blob();
      extension = 'wav';
    } else {
      file = fileUpload;
      extension = fileUpload.name.split('.').pop();
    }
    const name = `audio-${audioId}`;
    const directory = `voice-cloning/voices/${audioId}`;
    const s3Url = await uploadFileToS3(name, directory, extension, file);
    return s3Url;
  };

  const s3Url = await handleUploadAudioToS3();
  const response =
    await apis.instantVoiceTraining.qualityAudioVoiceInstantTraining({
      audioId,
      audioLink: s3Url,
    });

  if (response?.status) {
    return {
      isQuality: true,
      audioId,
      s3Url,
    };
  }
  return null;
};

export { getAudioUrl, truncateFilename, handleCheckQualityAudio };
